import { CreateProjectDto } from '@mottmac-moata/identity-sdk';
import { getProjectFormSchema, projectWithoutPCSchema } from '../schema';

export const isCreateProjectDto = (
  data: unknown,
  projectCollectionFeatureFlagOpen: boolean
): data is CreateProjectDto => {
  if (projectCollectionFeatureFlagOpen) return getProjectFormSchema('Create').safeParse(data).success;
  return projectWithoutPCSchema.safeParse(data).success;
};
